import reduxReducerHelper, { mapDefaultValuesToActions } from '../../utils/reduxReducerHelperUtil';

import { dataStoreHL7MessagesStates } from '../../hooks/useDataStoresHook/HL7Messages';

const dataStoreHl7MessagesActions = mapDefaultValuesToActions(dataStoreHL7MessagesStates);

export const dataStoreHL7MessagesReducer = reduxReducerHelper(dataStoreHl7MessagesActions, dataStoreHL7MessagesStates);
